import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { adminApi } from "../../lib/api";
import { ShieldCheck, ArrowRight, KeyRound } from "lucide-react";
import { FundleLogo } from "../../components/Brand";

export default function AdminLogin() {
    const navigate = useNavigate();
    const [u, setU] = useState("");
    const [p, setP] = useState("");
    const [err, setErr] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async () => {
        setBusy(true);
        setErr("");
        try {
            const r = await adminApi.post("/api/auth/admin/login", { username: u, password: p });
            localStorage.setItem("fx_admin_token", r.data.token);
            navigate("/admin");
        } catch (e) {
            setErr(e.response?.data?.detail || "Login failed");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-screen bg-white text-[#0b1437] flex flex-col">
            <header className="px-5 py-5 flex items-center justify-between">
                <Link to="/"><FundleLogo /></Link>
                <span className="fx-chip bg-[#f9fafb] text-[#6b7280] border border-[rgba(11,20,55,0.10)]">
                    <ShieldCheck size={12} /> Super Admin
                </span>
            </header>
            <main className="flex-1 flex items-center justify-center p-5 fx-grad-hero">
                <div className="w-full max-w-md fx-glass rounded-3xl p-7">
                    <h1 className="font-display text-3xl font-bold">Admin Console</h1>
                    <p className="text-[#6b7280] text-sm mt-1">Sign in with your super-admin credentials.</p>

                    <div className="mt-6 space-y-3">
                        <input
                            data-testid="admin-username-input"
                            value={u}
                            onChange={(e) => setU(e.target.value)}
                            placeholder="Username"
                            className="fx-input"
                            autoComplete="username"
                        />
                        <div className="flex items-center gap-2 fx-input">
                            <KeyRound size={16} className="text-[#c9a959]" />
                            <input
                                data-testid="admin-password-input"
                                type="password"
                                value={p}
                                onChange={(e) => setP(e.target.value)}
                                placeholder="Password"
                                className="flex-1 bg-transparent outline-none placeholder-[#9ca3af]"
                                autoComplete="current-password"
                                onKeyDown={(e) => e.key === "Enter" && submit()}
                            />
                        </div>
                        {err && <p className="text-red-400 text-sm">{err}</p>}
                        <button
                            data-testid="admin-login-btn"
                            onClick={submit}
                            disabled={busy}
                            className="fx-btn-primary w-full mt-2"
                        >
                            {busy ? "Signing in…" : "Sign in"} <ArrowRight size={16} />
                        </button>
                    </div>
                </div>
            </main>
        </div>
    );
}
